"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSongwriterLinkCriteria = exports.songwriterLinkSearchOptions = exports.SongwriterSearchFilters = void 0;
const public_search_writers_store_1 = __importDefault(require("@App/stores/search/public/public-search-writers-store"));
const uuid_1 = require("uuid");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const mobx_1 = require("mobx");
const songwriter_1 = require("@App/api/routes/songwriter/songwriter");
const check_is_empty_object_1 = require("@App/helpers/check-is-empty-object");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const form_field_types_1 = require("@App/enum/form-field-types");
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
exports.SongwriterSearchFilters = [
    {
        name: 'Writer filter',
        allowMultiple: false,
        filterFields: [
            {
                WRITER_FILTER: {
                    type: form_field_types_1.FormFieldTypes.RADIO,
                    name: 'inCatalogFilter',
                    options: [
                        { name: 'allWriters', label: 'Show all writers', default: true },
                        { name: 'onlyWritersInCatalog', label: 'Show only writers in my catalog' },
                        { name: 'excludeWritersInCatalog', label: 'Show only writers not in my catalog' },
                    ],
                    optional: false,
                    label: '',
                },
            },
        ],
    },
];
exports.songwriterLinkSearchOptions = [
    { id: (0, uuid_1.v4)(), value: 'fullName', label: 'Writer Name', shouldHide: true },
    { id: (0, uuid_1.v4)(), value: 'ipiNameNumber', label: 'Writer IPI', shouldHide: true },
];
exports.defaultSongwriterLinkCriteria = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(exports.songwriterLinkSearchOptions[0], true, false, undefined),
];
class SongwriterWriterSearchStore extends public_search_writers_store_1.default {
    constructor(rootStore) {
        super(rootStore);
        Object.defineProperty(this, "canAddCriteria", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "displayType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'songwriter'
        });
        Object.defineProperty(this, "_linkedSongwriters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "_hasSearched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "searchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.SongwriterSearchFilters
        });
        Object.defineProperty(this, "_currentSearchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { inCatalogFilter: 'allWriters' }
        });
        Object.defineProperty(this, "loadSongwriterWriterLinks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (writerIpIds) => __awaiter(this, void 0, void 0, function* () {
                const songwriterLinks = yield (0, songwriter_1.searchSongwriterWriterLinks)(this.rootStore.songwriterStore.currentSongwriterId, writerIpIds);
                (0, mobx_1.runInAction)(() => {
                    this._linkedSongwriters = songwriterLinks.data;
                });
            })
        });
        Object.defineProperty(this, "toggleSongwriterLink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (linkStatus, writerIpId) => __awaiter(this, void 0, void 0, function* () {
                if (linkStatus) {
                    const songwriterLink = yield (0, songwriter_1.linkSongwriterWriter)(this.rootStore.songwriterStore.currentSongwriterId, writerIpId);
                    (0, mobx_1.runInAction)(() => this._linkedSongwriters.push(songwriterLink.data));
                }
                else {
                    yield (0, songwriter_1.unlinkSongwriterWriter)(this.rootStore.songwriterStore.currentSongwriterId, writerIpId);
                    (0, mobx_1.runInAction)(() => this._linkedSongwriters.splice(this._linkedSongwriters.findIndex((writer) => writer.affWriterIpId === writerIpId), 1));
                }
            })
        });
        Object.defineProperty(this, "submitWriterUpdateRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (writerIpId, writerName, reason, formData) => __awaiter(this, void 0, void 0, function* () {
                return (0, songwriter_1.writerUpdateRequest)(this.rootStore.songwriterStore.currentSongwriterId, writerIpId, writerName, reason, formData);
            })
        });
        (0, mobx_1.makeObservable)(this, {
            _linkedSongwriters: mobx_1.observable,
            _hasSearched: mobx_1.observable,
            _currentSearchFilters: mobx_1.observable,
        });
    }
    setSearchFilters(filters) {
        this._currentSearchFilters = filters;
    }
    setWriterNameForSearch(name) {
        this.writerSearch.fullName = name;
    }
    searchForSongwritersCall(pagination) {
        return __awaiter(this, void 0, void 0, function* () {
            const writersSearchModel = yield (0, songwriter_1.searchSongwriterWriters)(pagination, this.rootStore.songwriterStore.currentSongwriterId, Object.assign(Object.assign({}, this.writerSearch), this._currentSearchFilters));
            return {
                data: writersSearchModel.data.content.map((writer) => public_search_writers_store_1.default.convertWriterToPartyDetails(writer)),
                count: writersSearchModel.data.totalElements,
            };
        });
    }
    searchForParties() {
        const _super = Object.create(null, {
            resetWritersAndWorks: { get: () => super.resetWritersAndWorks }
        });
        return __awaiter(this, arguments, void 0, function* (pagination = { page: 1, limit: this._currentPartyResultsPerPageLimit }) {
            if (this.writerSearch && (!(0, check_is_empty_object_1.isEmptyObject)(this.writerSearch) || !(0, check_is_empty_object_1.isEmptyObject)(this._currentSearchFilters))) {
                _super.resetWritersAndWorks.call(this);
                const result = yield this.searchForSongwritersCall(pagination);
                (0, mobx_1.runInAction)(() => {
                    this._searchResultPartyDetails = result.data;
                });
                if (pagination.limit && pagination.page && result.data) {
                    (0, mobx_1.runInAction)(() => {
                        this._totalNumberOfResults = result.count;
                        this._publicSearchByPartyCriteriaPaginationInfo = (0, calc_num_pages_1.calcNumPages)(result.count, pagination.limit, pagination.page);
                    });
                }
            }
            yield this.loadSongwriterWriterLinks(this._searchResultPartyDetails.map((party) => Number(party.ipId)));
            (0, mobx_1.runInAction)(() => (this._hasSearched = true));
        });
    }
    createWriterSearchCriteriaStore() {
        return new search_criteria_store_1.default(exports.defaultSongwriterLinkCriteria, exports.songwriterLinkSearchOptions, search_option_type_1.SearchOptionType.filter, required_criteria_1.RequiredCriteria.some, 2);
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = this.createWriterSearchCriteriaStore();
    }
    resetStore() {
        super.resetStore();
        this._currentSearchFilters = { inCatalogFilter: 'allWriters' };
        this._hasSearched = false;
    }
    get linkedSongwriters() {
        return this._linkedSongwriters;
    }
    get hasSearched() {
        return this._hasSearched;
    }
}
exports.default = SongwriterWriterSearchStore;
